import { useParams } from "react-router";
import { Alert, AlertDescription } from "@/components/ui/alert";
import {
  useClientPreferences,
  useDynamicPortfolio,
  usePortfolioCollection,
  useProducts,
  useWrapperTypes,
} from "@/lib/hooks/use-portfolio-collections";
import { useT } from "@/lib/i18n/use-t";

import { PortfolioEditorSkeleton } from "../../skeleton-loaders";
import { DynamicPortfolioProductsEditor } from "./dynamic-portfolio-products-editor";
import { T } from "./page.i18n";

export default function DynamicPortfolioPage() {
  const { id, dynamicPortfolioId } = useParams<{ id: string; dynamicPortfolioId: string }>();
  const t = useT(T);

  const {
    dynamicPortfolio,
    error: portfolioError,
    isLoading: portfolioLoading,
  } = useDynamicPortfolio(id!, dynamicPortfolioId!);
  const { products, error: productsError, isLoading: productsLoading } = useProducts(id!);
  const { collection } = usePortfolioCollection(id!);
  const { clientPreferences } = useClientPreferences(id!);
  const wrapperTypesEnabled = !!collection?.wrapperTypesEnabled;
  // Query is disabled while the feature is off — no wasted request.
  const { wrapperTypes } = useWrapperTypes(wrapperTypesEnabled ? id! : null);

  if (portfolioLoading || productsLoading) {
    return <PortfolioEditorSkeleton />;
  }

  if (portfolioError || productsError || !dynamicPortfolio) {
    return (
      <Alert variant="destructive">
        <AlertDescription>{t.failedToLoad}</AlertDescription>
      </Alert>
    );
  }

  return (
    <DynamicPortfolioProductsEditor
      collectionId={id!}
      portfolio={dynamicPortfolio}
      products={products}
      wrapperTypes={wrapperTypesEnabled ? wrapperTypes : []}
      showPreferenceTilt={clientPreferences.length > 0}
    />
  );
}
